import React from 'react';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const steps = [
  { title: 'Upload or Import', description: 'Drag-and-drop files, copy a YouTube link, or sync from cloud storage.' },
  { title: 'Analyze & Review', description: 'See AI highlights populate in real time while transcripts and thumbnails render.' },
  { title: 'Publish Clips', description: 'Send polished clips to TikTok, YouTube, Instagram, or download the master export.' },
];

const VideosOverview: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Video Library - ClipThis"
        description="Manage source recordings, transcripts, and clip-ready cuts from a single library."
        url="/videos"
      />
      <BreadcrumbSchema items={[{ name: 'Videos', path: '/videos' }]} />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-5xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">Video Library</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Long-form in, platform-ready out</h1>
          <p className="text-lg text-gray-600 mb-10">
            Organize livestreams, podcasts, webinars, and VODs. ClipThis keeps transcripts, highlights, and exports connected to the original file so you never lose context.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            {steps.map((step) => (
              <div key={step.title} className="p-6 rounded-2xl border border-gray-200 bg-gray-50">
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">{step.title}</h2>
                <p className="text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default VideosOverview;

